/**
 * Navbar Color Configuration
 * 
 * This configuration allows you to customize the navbar appearance:
 * - Background color
 * - Link color
 * - Link hover color
 * - Mobile menu background
 * 
 * Example configurations:
 * 
 * Light Theme:
 * {
 *   backgroundColor: '#ffffff',
 *   linkColor: '#000000',
 *   linkHoverColor: '#FF6B00',
 *   mobileMenuBg: '#f5f5f5',
 * }
 * 
 * Dark Theme:
 * {
 *   backgroundColor: '#1a1a1a',
 *   linkColor: '#ffffff',
 *   linkHoverColor: '#FF6B00',
 *   mobileMenuBg: '#2d2d2d',
 * }
 */

// Default static configuration
const defaultNavbarColorConfig = {
  // Navbar background color
  backgroundColor: '#F1F2F4',     // Light gray background

  // Link color (text color in navbar)
  linkColor: '#080808',           // Dark text

  // Link hover color
  linkHoverColor: '#d210f9',      // Purple hover

  // Mobile menu background color
  mobileMenuBg: '#F1F2F4',        // Light gray background for mobile menu

  // Mobile menu text color
  mobileMenuTextColor: '#080808', // Dark text in mobile menu

  // Mobile menu hover color
  mobileMenuHoverColor: '#d210f9', // Purple hover in mobile menu
};

// This will be set dynamically by the theme system
let navbarColorConfig = { ...defaultNavbarColorConfig };

/**
 * Get navbar color configuration
 * @returns {object} The entire navbar color configuration
 */
export const getNavbarColorConfig = () => {
  return navbarColorConfig;
};

/**
 * Get CSS custom properties for navbar colors
 * @returns {object} CSS custom properties object
 */
export const getNavbarColorCSSVariables = () => {
  return {
    '--navbar-bg': navbarColorConfig.backgroundColor,
    '--navbar-link-color': navbarColorConfig.linkColor,
    '--navbar-link-hover-color': navbarColorConfig.linkHoverColor,
    '--navbar-mobile-bg': navbarColorConfig.mobileMenuBg,
    '--navbar-mobile-text': navbarColorConfig.mobileMenuTextColor,
    '--navbar-mobile-hover': navbarColorConfig.mobileMenuHoverColor,
  };
};

/**
 * Update navbar color configuration from theme data
 * @param {object} themeData - Theme data with navbar object
 */
export const updateNavbarColorConfigFromTheme = (themeData) => {
  if (themeData && themeData.navbar) {
    navbarColorConfig = {
      backgroundColor: themeData.navbar.backgroundColor || defaultNavbarColorConfig.backgroundColor,
      linkColor: themeData.navbar.linkColor || defaultNavbarColorConfig.linkColor,
      linkHoverColor: themeData.navbar.linkHoverColor || defaultNavbarColorConfig.linkHoverColor,
      mobileMenuBg: themeData.navbar.mobileMenuBg || defaultNavbarColorConfig.mobileMenuBg,
      mobileMenuTextColor: themeData.navbar.mobileMenuTextColor || defaultNavbarColorConfig.mobileMenuTextColor,
      mobileMenuHoverColor: themeData.navbar.mobileMenuHoverColor || defaultNavbarColorConfig.mobileMenuHoverColor,
    };
  }
};

export { navbarColorConfig as default };
